import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Tracking } from '../../../../../../pages/project/settings/Tracking';
import { RoutePending } from '../../../../../../components/molecules/loader/RoutePending';
import { getProjectQuizesQueryOptions } from '../../../../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/tracking')({
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(getProjectQuizesQueryOptions(context.apiClient, params.project_id));
  },
  component: TrackingRoute,
  pendingComponent: () => <RoutePending label="Loading tracking settings..." />,
});

function TrackingRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <Tracking projectId={project_id} portalApiClient={apiClient} />;
}
